import React from "react";
import { Box } from "@material-ui/core";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import EasyApplyForm from "./EasyApplyForm";

const THEME = createTheme({
  typography: {
    fontFamily: `"Open Sans", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&:hover $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&$focused $notchedOutline": {
          borderColor: "#F4F7FC",
        },
        "&$disabled $notchedOutline": {
          borderColor: "#F4F7FC",
        },
      },
    },
  },
});

const ApplyFormContainer = () => {
  return (
    <MuiThemeProvider theme={THEME}>
      <Box>
        <EasyApplyForm />
      </Box>
    </MuiThemeProvider>
  );
};
export default ApplyFormContainer;
